import React, {useRef, useState} from 'react';
import ReactDOM from 'react-dom';
import styled from "styled-components";


const WrapperStyled = styled.div`
    padding: 20px;
    z-index: 8123;
    position: fixed;
    background: #fff;
    box-shadow: var(--mui-shadows-24);
    
    
    .dra-actions{
        height: 30%;
    }
`;

const ContentStyled = styled.div`

`;

const DragabbleBacklessModal = ({children, width = 400, height = 200}) => {
    const ref = useRef(null);

    const [dragging, setDragging] = useState(false);
    const [position, setPosition] = useState({x: 0, y: 0});
    const [offset, setOffset] = useState({x: 0, y: 0});

    const handleMouseDown = (e) => {
        setDragging(true);
        setOffset({
            x: e.clientX - position.x,
            y: e.clientY - position.y,
        });
    };

    const handleMouseMove = (e) => {
        if (dragging) {
            setPosition({
                x: e.clientX - offset.x,
                y: e.clientY - offset.y,
            });
        }
    };

    const handleMouseUp = () => {
        setDragging(false);
    };

    return ReactDOM.createPortal(
        <WrapperStyled
            ref={ref}
            style={{width, height, left: `${position.x}px`, top: `${position.y}px`}}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
        >
            <div className="modal">
                <ContentStyled>
                    {children}
                </ContentStyled>
            </div>
        </WrapperStyled>,
        document.getElementById('customPortal'));
};

export default DragabbleBacklessModal;